import { render, staticRenderFns } from "./CardWarningMessage.vue?vue&type=template&id=79a61936&scoped=true&"
import script from "./CardWarningMessage.vue?vue&type=script&lang=ts&"
export * from "./CardWarningMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a61936",
  null
  
)

export default component.exports